import { useEffect } from "react";
import {
  attachClickTracking,
  attachScrollTracking,
  attachTimeOnPageTracking,
  trackPageView,
} from "../../../analytics";
import { useLocation } from "../navigation";

export function AnalyticsTracker() {
  const { pathname } = useLocation();

  useEffect(() => attachClickTracking(), []);

  useEffect(() => {
    let cleanupScroll = () => {};
    let cleanupTime = () => {};

    const timer = window.setTimeout(() => {
      const pagePath = `${window.location.pathname}${window.location.search}`;
      trackPageView(pagePath, document.title);
      cleanupScroll = attachScrollTracking();
      cleanupTime = attachTimeOnPageTracking();
    }, 0);

    return () => {
      window.clearTimeout(timer);
      cleanupScroll();
      cleanupTime();
    };
  }, [pathname]);

  return null;
}
